import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Document, Page } from 'react-pdf';

export class PdfLayout extends Component {
  constructor() {
    super()
    this.state = {
      totalNoOfPage: []
    }
  }
  setPages(numPages) {
    const totalPages = Array.from({ length: numPages }, (_, index) => index + 1)
    this.setState({ totalNoOfPage: totalPages })
    const resl = document.getElementsByClassName('displayBlock')
  }
  render() {
    return (
      <div className={css(Styles.displayBlock)}>
        <Document
          // file={require('../assets/sampleads.pdf')}
          file={require('../assets/HorizonPdf.pdf')}
          // file={require('../assets/VertPdf.pdf')}
          onLoadSuccess={(e) => this.setPages(e.numPages)}
          onLoadError={(error) => console.log('PDF Inside Error', error)} >
          {/* {
            this.state.totalNoOfPage.map((x, index) => (
              <div key={'pdf-' + index} className={css(Styles.singlePageBlock)}>
                <Page className={css(Styles.perPage)} pageNumber={x} />
              </div>
            ))
          } */}
          <div key={'pdf-1'} className={css(Styles.singlePageBlock)}>
            <Page className={css(Styles.perPage)} pageNumber={1} />
          </div>
        </Document>
      </div>
    );
  }
}
const Styles = StyleSheet.create({
  displayBlock:{
    background: '#000',
    width: '100%'
  },
  singlePageBlock:{
    height: '100vh',
    width: '100vw',
    overflow: 'hidden'
  }
})


// WEBPACK FOOTER //
// ./src/screens/PdfLayout.js